"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _airbnbPropTypes = require("airbnb-prop-types");

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _clickOutside = _interopRequireDefault(require("../ClickOutside/clickOutside"));

var _reactTransitionGroup = require("react-transition-group");

var _unique = _interopRequireDefault(require("../helpers/unique.id"));

var _compareElementType = _interopRequireDefault(require("../helpers/compare-element-type"));

var _Scrollable = _interopRequireDefault(require("../Scrollable"));

var _portal = require("../Portal/portal");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var TRANSITION_TIMEOUT = 500;

var PanelsLayout = function PanelsLayout(_ref) {
  var children = _ref.children;
  var activePanel, isPanelOver, isSmall, isLarge, isFromLeft;

  var childrenArr = _react.default.Children.toArray(children);

  childrenArr.find(function (child) {
    var _child$props = child.props,
        active = _child$props.active,
        over = _child$props.over,
        small = _child$props.small,
        large = _child$props.large,
        openLeft = _child$props.openLeft;
    if ((0, _compareElementType.default)(child, Panel, true) || !active || activePanel) return;
    isPanelOver = !!over;
    isSmall = !!small;
    isLarge = !!large;
    isFromLeft = !!openLeft;
    activePanel = child;
  });
  var processedChildren = childrenArr.map(function (child, index) {
    var isContent = (0, _compareElementType.default)(child, Content);
    return _react.default.cloneElement(child, {
      active: child === activePanel || isContent && !!activePanel
    });
  });
  var classes = {
    'co-panels-layout': true,
    'co-panels-layout--from-left': isFromLeft,
    'co-panels-layout__panel--over': isPanelOver
  };
  var modifiers = {
    small: isSmall,
    large: isLarge
  };
  return _react.default.createElement(_styler.default, {
    classNames: classes,
    modifiers: modifiers
  }, function (styles) {
    return _react.default.createElement("div", {
      className: styles
    }, processedChildren);
  });
};

var Content = function Content(_ref2) {
  var children = _ref2.children,
      active = _ref2.active;
  return _react.default.createElement(_styler.default, {
    classNames: "co-panels-layout__content",
    modifiers: {
      active: active
    }
  }, function (styles) {
    return _react.default.createElement("div", {
      className: styles
    }, children);
  });
};

var PanelContent = function PanelContent(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement(_styler.default, {
    classNames: "co-panels-layout__panel-content"
  }, function (styles) {
    return _react.default.createElement(_Scrollable.default, null, _react.default.createElement("div", {
      className: styles
    }, children));
  });
};

var Panel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Panel, _React$Component);

  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Panel).call(this, props));
    _this.id = _this.props.id || (0, _unique.default)();
    return _this;
  }

  _createClass(Panel, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          active = _this$props.active,
          small = _this$props.small,
          large = _this$props.large,
          openLeft = _this$props.openLeft,
          over = _this$props.over,
          overlay = _this$props.overlay,
          children = _this$props.children,
          _onClickOutside = _this$props.onClickOutside;
      var allowedModifiers = {
        active: active,
        small: small,
        large: large
      };
      var overlayNode = overlay ? _react.default.createElement(_styler.default, {
        classNames: "co-panels-layout__overlay",
        modifiers: {
          active: active
        }
      }, function (styles) {
        return _react.default.createElement("div", {
          className: styles
        });
      }) : null;
      return _react.default.createElement(_react.default.Fragment, null, overlayNode, _react.default.createElement(_reactTransitionGroup.Transition, {
        in: active,
        timeout: TRANSITION_TIMEOUT
      }, function (state) {
        var classes = {
          'co-panels-layout__panel': true,
          'co-panels-layout__panel--over': over,
          'co-panels-layout__panel--from-left': openLeft,
          'co-panels-layout__panel--exiting': state === 'exiting'
        };
        return _react.default.createElement(_styler.default, {
          classNames: classes,
          modifiers: allowedModifiers
        }, function (styles) {
          return _react.default.createElement(_clickOutside.default, {
            onClickOutside: function onClickOutside(e) {
              if (active && !(0, _portal.isInPortal)(e)) {
                _onClickOutside(e);
              }
            }
          }, _react.default.createElement("div", {
            id: _this2.id,
            className: styles,
            tabIndex: "-1"
          }, state !== 'exited' ? children : null));
        });
      }));
    }
  }]);

  return Panel;
}(_react.default.Component);

Content.displayName = 'PanelsLayout.Content';
Panel.displayName = 'PanelsLayout.Panel';
var exclusiveSizes = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('small', 'large');
PanelsLayout.propTypes = {
  children: _propTypes.any
};
Content.propTypes = {
  children: _propTypes.any
};
Panel.defaultProps = {
  onClickOutside: function onClickOutside() {}
};
Panel.propTypes = {
  children: _propTypes.any,
  id: _propTypes.string,
  active: _propTypes.bool,

  /** {bool} Does not shrink the panel content */
  over: _propTypes.bool,

  /** {bool} Displays an overlay over the panel content */
  overlay: _propTypes.bool,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  small: exclusiveSizes,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  large: exclusiveSizes,

  /** {bool} Opens panel from the left side of the viewport */
  openLeft: _propTypes.bool,
  onClickOutside: _propTypes.func
};
PanelsLayout.Content = Content;
PanelsLayout.Panel = Panel;
PanelsLayout.Panel.Content = PanelContent;
var _default = PanelsLayout;
exports.default = _default;
PanelsLayout.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PanelsLayout",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": ""
    }
  }
};